export class Supplier {
  public id: number;
  public supplierCode: string;
  public supplierName: string;
  public inventoryAccount: string;
  public currencyCode: string;
  public contactFirstName: string;
  public contactLastName: string;
  public contactEmail: string;
  public address1: string;
  public address2: string;
  public contactTelephone: string;
  public city: string;
  public state: string;
  public postalCode: string;
  public country: string;
  public status:boolean;

  constructor() {
    this.id = 0;
    this.supplierCode = "";
    this.supplierName = "";
    this.inventoryAccount = "";
    this.currencyCode = "";
    this.contactFirstName = "";
    this.contactLastName = "";
    this.contactEmail = "";
    this.address1 = "";
    this.address2 = "";
    this.contactTelephone = "";
    this.city = "";
    this.state = "";
    this.postalCode = "";
    this.country = "";
    this.status=false;
  }
}
export interface SupplierOverViewProps {
  id: number;
  code: string;
  name: string;
  city: string;
  state_province: string;
  is_active: number;
  contact_name: string;
  contact_phone: string;
  contact_email: string | null;
}
export interface SupplierForm{
  client: {
    code: any;
    name: any;
  };
  code: string;
  name: string;
  address_line_1: string;
  address_line_2: string;
  address_line_3: string;
  city: string;
  state_province: string;
  postal_code: string;
  country: any;
  contact_name: string;
  contact_phone: string;
  contact_phone_ext: string;
  contact_email: string;
  is_active: boolean;
  is_residential: boolean;
};
export const defaultFormData: SupplierForm = {
  client: {
    code: "",
    name: "",
  },
  code: "",
  name: "",
  address_line_1: "",
  address_line_2: "",
  address_line_3: "",
  city: "",
  state_province: "",
  postal_code: "",
  country: "",
  contact_name: "",
  contact_phone: "",
  contact_phone_ext: "",
  contact_email: "",
  is_active: true,
  is_residential: false,
};